module.exports = __webpack_public_path__ + "static/img/allianz-logo.b59b9d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/allianz-logo.png
// module id = 430
// module chunks = 6